import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { REGISTER_URL, WHATSAPP_URL } from "@/lib/site";

const FAQS = [
    {
        q: "Is this suitable for beginners?",
        a: "Yes. The first workshop is designed for beginners, and the full series builds step by step from basic understanding to publication readiness.",
    },
    {
        q: "Can I join only one workshop?",
        a: "Yes. You can register for one workshop, selected bundles or the full five-workshop series.",
    },
    {
        q: "Are the workshops online?",
        a: "Yes. All sessions are conducted live online.",
    },
    {
        q: "Will I receive a certificate?",
        a: "Yes. Participants will receive a certificate of attendance.",
    },
    {
        q: "Will recordings be provided?",
        a: "Recording access may be subject to organiser arrangement. Please contact the organiser for confirmation.",
    },
    {
        q: "Do I need to have a research topic already?",
        a: "No. Workshop 1 is suitable for participants who are still exploring or refining their topic.",
    },
    {
        q: "Can I join if I already have interview data?",
        a: "Yes. Workshops 4 and 5 are suitable for participants who already have transcripts or findings to write.",
    },
    {
        q: "How do I register?",
        a: (
            <>
                Click any <span className="font-semibold text-[color:var(--navy)]">Register Now</span>{" "}
                button and complete the Google Form.{" "}
                <a
                    href={REGISTER_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-4 text-[color:var(--maroon)]"
                >
                    Open the form here
                </a>
                .
            </>
        ),
    },
];

export default function FAQ() {
    return (
        <section id="faq" data-testid="faq-section" className="py-20 md:py-28 bg-[color:var(--paper-tint)]">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <div className="font-mono-label text-[color:var(--maroon)]">
                        Frequently Asked
                    </div>
                    <h2
                        className="mt-3 font-serif text-4xl sm:text-5xl text-[color:var(--navy)] tracking-tight leading-tight"
                        style={{ fontWeight: 500 }}
                    >
                        Quick answers before you register.
                    </h2>
                    <div className="hr-gold mt-5 mx-auto" />
                </div>

                <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="border-b border-[color:var(--line)]"
                            data-testid={`faq-item-${i + 1}`}
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i + 1}`}
                                className="text-left font-serif text-lg sm:text-xl text-[color:var(--navy)] py-5 hover:no-underline"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-slate-700 text-base leading-relaxed pb-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>

                <div className="mt-10 text-center text-sm text-slate-600">
                    Still have a question?{" "}
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="faq-whatsapp-link"
                        className="font-semibold text-[color:var(--navy)] underline underline-offset-4"
                    >
                        Message us on WhatsApp
                    </a>
                    .
                </div>
            </div>
        </section>
    );
}
